import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Skeleton from 'components/cmn/TableBodySkeleton';

export default function AccountProjectListTableBodySkeleton(): JSX.Element {
  return (
    <TableBody>
      {Array.from(new Array(7)).map((row, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={index} sx={{ height: '56px' }}>
            <TableCell>
              <Skeleton width={150} />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="circular" width={30} height={30} />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="circular" width={30} height={30} />
            </TableCell>
            <TableCell>
              <Skeleton />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
}
